import styled from 'styled-components'

const StyledCoursePreviewContentLesson = styled.div`
  .lesson-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    width: 100%;
    text-align: left;

    .lesson-details-container {
      display: flex;
      align-items: center;

      .lesson-thumbnail {
        height: 38px;
        width: 68px;
        border-radius: 3px;
        background-color: ${({ theme }) => theme.color.gray[100]};
        margin-right: 12px;
        flex-shrink: 0;
        overflow: hidden;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          border-radius: 3px;
          box-shadow: inset 0 0 0 1px rgb(0, 0, 0, 0.1);
          z-index: 1;
        }
      }

      .lesson-details {
        .lesson-label {
          font-size: 10px;
          font-weight: 600;
          color: ${({ theme }) => theme.color.gray[500]};
          letter-spacing: 0.1rem;
          text-transform: uppercase;
          display: block;
        }

        .lesson-title {
          font-size: 14px;
          font-weight: 500;
          color: ${({ theme }) => theme.color.gray[700]};
          margin-top: 4px;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-align: left;
          -webkit-box-orient: vertical;
        }
      }
    }

    .lesson-actions {
      display: flex;
      align-items: center;
      margin-left: 20px;
      flex-shrink: 0;

      .lesson-time {
        font-size: 13px;
        color: ${({ theme }) => theme.color.gray[400]};
        margin-left: 16px;
        text-align: right;
        flex-shrink: 0;
      }

      .lesson-expand-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 28px;
        width: 28px;
        border-radius: 50%;
        margin-left: 14px;
        flex-shrink: 0;
        background-color: ${({ theme }) => theme.color.gray[100]};
        color: ${({ theme }) => theme.color.gray[500]};

        svg {
          height: 16px;
          width: 16px;
          stroke-width: 3px;
          flex-shrink: 0;
        }
      }
    }
  }

  .lesson-offerings {
    padding-left: calc(68px + 12px + 13px);
    margin: 6px 0 0 0;
    font-size: 13px;
    display: grid;
    gap: 4px;
    color: ${({ theme }) => theme.color.gray[400]};
  }
`

export default StyledCoursePreviewContentLesson
